module.exports = __webpack_public_path__ + "static/media/66.3fdbe31.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/66.wav
// module id = zMV3
// module chunks = 0